<template>
	<div class="spinner-wrapper">
		<div class="lds-dual-ring"></div>
	</div>
</template>
<script>
export default {
	name: 'LoadingSpinner',
};
</script>
<style scoped>
.spinner-wrapper {
	width: 100vw;
	height: 100vh;
	position: absolute;
	top: 0px;
	right: 0px;
	bottom: 0px;
	left: 0px;
	z-index: 10000;
	background-color: #fff;
	opacity: 0.3;
}
.lds-dual-ring {
	position: absolute;
	top: 50%;
	left: 50%;
	margin: -50px 0 0 -50px;
	transform: scale(0.7);
}
.lds-dual-ring:after {
	content: ' ';
	display: block;
	width: 64px;
	height: 64px;
	margin: 8px;
	border-radius: 50%;
	border: 6px solid #3b53dc;
	border-color: #3b53dc transparent #3b53dc transparent;
	animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}
</style>
